import React from 'react';
import { CircularProgress, Box } from 'src/components';

const CardLoadingIndicator = () => {
  return (
    <Box className="absolute top-0 left-0 w-full h-full flex justify-center items-center bg-white/80 z-10">
      <CircularProgress color="neutral" size="sm" />
    </Box>
  );
};

export default CardLoadingIndicator;
